import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';

const SearchBar = ({ onSearch }) => {
  const [searchTerm, setSearchTerm] = useState('');

  const handleSearch = (e) => {
    const value = e?.target?.value;
    setSearchTerm(value);
    onSearch(value);
  };

  const handleClear = () => {
    setSearchTerm('');
    onSearch('');
  };

  return (
    <div className="relative">
      <Input
        type="search"
        placeholder="Search within report..."
        value={searchTerm}
        onChange={handleSearch}
        className="pr-20"
      />
      <div className="absolute right-2 top-1/2 -translate-y-1/2 flex items-center gap-1">
        {searchTerm && (
          <button
            onClick={handleClear}
            className="p-1 hover:bg-muted rounded transition-colors"
            aria-label="Clear search"
          >
            <Icon name="X" size={16} />
          </button>
        )}
        <button
          className="p-1 hover:bg-muted rounded transition-colors"
          aria-label="Search"
        >
          <Icon name="Search" size={16} />
        </button>
      </div>
    </div>
  );
};

export default SearchBar;